import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import { getAvailableSubRegions } from 'store/search/searchSelectors';
import { getQuerySubRegions } from 'store/router/routerSelectors';
import MultiSelectFilter from 'components/Filters/MultiSelectFilter';

const SubRegionFilter = ({ onChange, hideCount, displayClearFilter, onClearFilter }) => {
  const availableSubRegions = useSelector(getAvailableSubRegions);
  const selectedSubRegions = useSelector(getQuerySubRegions);

  return (
    <MultiSelectFilter
      title="Area"
      filterKey="subRegions"
      availableItems={availableSubRegions}
      selectedItems={selectedSubRegions}
      onChange={onChange}
      hideCount={hideCount}
      displayClearFilter={displayClearFilter}
      onClearFilter={onClearFilter}
      displayPlusIcon
      data-testid="sub-region-filter"
    />
  );
};

SubRegionFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  hideCount: PropTypes.bool,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

SubRegionFilter.defaultProps = {
  hideCount: false,
  displayClearFilter: false,
  onClearFilter: noop,
};

export default SubRegionFilter;
